<ng-container>
<app-parent-create-exhibition
    [isForEdit]="isForEdit"
    [exhibition_obj]="exhibition_obj"
></app-parent-create-exhibition>
</ng-container>
